import { Navigate, useLocation } from "react-router-dom"

import { useAuth } from "providers/auth"

const RequireAuth: React.FC = ({ children }) => {
  const { user } = useAuth()
  const location = useLocation()

  if (user) return <>{children}</>

  return (
    <Navigate
      to={{
        pathname: "/auth/sign-in",
      }}
      state={{ redirectTo: location.pathname + location.search }}
    />
  )
}

export default RequireAuth
